<template>
    
    
    <div class="fire clr">
        
        <div class="user_add fs-xxl text-centr mt-5 mb-5 cursor-pointer" v-if="!obj_to_null(this.user)">
            <div class="add user " @click="add_user">
                <i title="" class="fa add_user fa-plus-square" data-type="delegate_users"></i>
                <span>Оберіть користувача</span>
            </div>
        </div>
        
        <div class="user_to_fire mx-auto col-xs-10 col-6 mt-5" v-else>
                <user_block v-if="parseInt(form.user_id) > 0"
                            :key="form.user_id"
                            v-bind:can_del=true
                            v-bind:del_triger="remove_fire_from_doc"
                            v-bind:user_id="parseInt(form.user_id)">
                </user_block>
        </div>
        
        <standart title="Звільнення" key="fire_addon" v-bind:is_active_result=false v-bind:is_active_problem=false></standart>
    </div>
</template>

<script>
import standart from '../standart.vue';
import user_block from "../../../../../../shared/user/user_block/user_block.vue";
import {createHelpers} from 'vuex-map-fields';
const {mapFields} = createHelpers({
    getterType: 'memorandum_create/getMemCreateField',
    mutationType: 'memorandum_create/updateMemCreateField',
});

export default {
    name: "fire",
    components: {
        standart,
        user_block
    },
    data() {
        return {
            uniq_u: 'fire_user_add',
            user: {},
            remove_fire_from_doc: 'remove_fire',
            form: {
                user_id: 0,
            }
        }
    },
    
    
    created() {
        EventBus.$on('selected_users', e => {
            if (e.uniq === this.uniq_u) {
                EventBus.$emit('close_u_filter');
                this.load_fire_user(e.users[0]);
            }
        });
        
        EventBus.$on(this.remove_fire_from_doc, e => {
            this.clean_user();
        });
    },
    
    mounted() {
    
    },
    
    methods: {
        add_user() {
            EventBus.$emit('load_users_filter', {
                    uniq: this.uniq_u,
                    active: [],
                }
            );
        },
        
        
        clean_user() {
            this.form.user_id = 0;
            this.user = {};
            this.mem_title = '';
            this.mem_preamblua = '';
        },
        
        async load_fire_user(user) {
            IMC_CORE.showloading();
            this.clean_user();
            this.form.user_id = parseInt(user.id);
            
            await api.get('/hr/user/' + parseInt(user.id))
                .then(({data}) => {
                    IMC_CORE.hideloading();
                    if (data.status === "operation_success") {
                        EventBus.$emit('remove_dir');
                        if (data.data !== undefined) {
                            this.user = data.data;
                            
                            if (this.user.hasOwnProperty('hr_data')) {
                                let hr_data = this.user.hr_data;
                                
                                if(hr_data.hasOwnProperty('user_short')) {
                                    this.mem_title = hr_data.user_short;
                                }
                                
                                if(hr_data.hasOwnProperty('text_formatted')) {
                                    this.mem_preamblua = hr_data.text_formatted;
                                }
                            }
                        }
                    } else {
                        EventBus.$emit('show_toast', {err: data.message, type: "danger", title: data.status})
                    }
                }).catch(err => {
                    IMC_CORE.hideloading();
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
                });
        }
    },
    
    computed: {
        ...mapFields([
            'active_memorandum'
        ]),
        
        mem_title: {
            get() {
                return this.active_mem.title;
            },
            set(value) {
                this.$store.dispatch('memorandum_create/UPDATE_ACTIVE_MEM', {title: value});
            }
        },
        
        mem_preamblua: {
            get() {
                return this.active_mem.preamblua;
            },
            set(value) {
                this.$store.dispatch('memorandum_create/UPDATE_ACTIVE_MEM', {preamblua: value});
            }
        },
        
        return_data : function () {
            return this.form;
        },
    },
    
}

</script>

<style scoped>
</style>
